import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
export const BAILLEURS_DOSSIER_IS_ACCESSIBLE_QUERY = gql `
        query isAccessible($dossierId: Long) {
          bailleurs_dossier_is_accessible(dossierId: $dossierId) {
            accessible,
            message
        }
      }
    `;
export const useBailleursDossierIsAccessibleLazyQuery = (options) => {
    return useLazyQuery(BAILLEURS_DOSSIER_IS_ACCESSIBLE_QUERY, Object.assign({ errorPolicy: 'all' }, options));
};
export const useBailleursDossierIsAccessibleQuery = (options) => {
    return useQuery(BAILLEURS_DOSSIER_IS_ACCESSIBLE_QUERY, Object.assign({ errorPolicy: 'all' }, options));
};
export const useBailleursDossierIsAccessibleQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: BAILLEURS_DOSSIER_IS_ACCESSIBLE_QUERY, variables }));
};
